import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "AlarmSubtract"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.3112 2.99634L17.25 4.05609L19.9358 6.74784L20.997 5.68809L18.3112 2.99634ZM3 5.69407L5.6865 3.00232L6.7485 4.06207L4.062 6.75382L3 5.69407ZM12 21.0001C7.44365 21.0001 3.75 17.3065 3.75 12.7501C3.75 8.19377 7.44365 4.50012 12 4.50012C16.5563 4.50012 20.25 8.19377 20.25 12.7501C20.25 14.9382 19.3808 17.0366 17.8336 18.5837C16.2865 20.1309 14.188 21.0001 12 21.0001ZM15.75 11.9963V13.4963H8.25V11.9963H15.75ZM5.25 12.7501C5.25 9.02219 8.27208 6.00012 12 6.00012C15.7279 6.00012 18.75 9.02219 18.75 12.7501C18.75 16.478 15.7279 19.5001 12 19.5001C8.27208 19.5001 5.25 16.478 5.25 12.7501Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/AlarmSubtract.vue"]]);
